import type { FontKey } from "./metrics";

export interface FontFile { key: FontKey; family: string; weight: 400 | 600; style: "normal" | "italic"; file: string }

export const FONT_FILES: FontFile[] = [
  { key: "display", family: "Newsreader", weight: 400, style: "normal", file: "Newsreader-Regular" },
  { key: "displayItalic", family: "Newsreader", weight: 400, style: "italic", file: "Newsreader-Italic" },
  { key: "body", family: "Schibsted Grotesk", weight: 400, style: "normal", file: "SchibstedGrotesk-Regular" },
  { key: "bodyBold", family: "Schibsted Grotesk", weight: 600, style: "normal", file: "SchibstedGrotesk-SemiBold" },
  { key: "mono", family: "JetBrains Mono", weight: 400, style: "normal", file: "JetBrainsMono-Regular" },
  { key: "monoBold", family: "JetBrains Mono", weight: 600, style: "normal", file: "JetBrainsMono-SemiBold" },
];

export const FONT_BY_KEY = Object.fromEntries(FONT_FILES.map((f) => [f.key, f])) as Record<FontKey, FontFile>;

const FALLBACK: Record<string, string> = {
  Newsreader: "'Iowan Old Style', Georgia, serif",
  "Schibsted Grotesk": "'Helvetica Neue', Arial, sans-serif",
  "JetBrains Mono": "Menlo, Consolas, monospace",
};

export const fontStack = (k: FontKey) => { const f = FONT_BY_KEY[k]; return `'${f.family}', ${FALLBACK[f.family]}`; };

/** @font-face rules; `src` maps a FontFile to a url()/data: URI (format is inferred from the URI). */
export function fontFaceCss(keys: Iterable<FontKey>, src: (f: FontFile) => string | undefined): string {
  const out: string[] = [];
  for (const k of new Set(keys)) {
    const f = FONT_BY_KEY[k], u = src(f);
    if (!u) continue;
    const fmt = /woff2/.test(u.slice(0, 40)) || u.endsWith(".woff2") ? "woff2" : "truetype";
    out.push(`@font-face{font-family:'${f.family}';font-style:${f.style};font-weight:${f.weight};font-display:block;src:url(${JSON.stringify(u)}) format('${fmt}')}`);
  }
  return out.join("\n");
}
